export interface ProsumerState {
  isProsumer: number | null
}

export const InitialState: ProsumerState = {
  isProsumer: null,
}
